import AuthLayout from './Layout';

export default AuthLayout;
